import React from 'react';
import { Box, CircularProgress, Alert } from '@mui/material';
import { useProjectDocuments } from '../../hooks/useProjectDocuments'
import EmpleadosHabilitacionDashboard from '../../components/administracion/EnableEmployeesDashboard';
import { useParams } from "react-router-dom";

const EmpleadosHabilitacionPage = () => {
    /*const { projectId } = useParams();
    const {
        empleadosHabilitacion,
        isLoadingHabilitacion,
        errorHabilitacion,
    } = useProjectDocuments(projectId);

    if (isLoadingHabilitacion) return <CircularProgress />;
    if (errorHabilitacion) return <Alert severity="error">Error al cargar empleados habilitados.</Alert>;*/

    return (
        <Box sx={{ p: 2 }}>
            <EmpleadosHabilitacionDashboard
                //windows={empleadosHabilitacion}
                onReorder={(newOrder) => {
                    console.log('Nuevo orden de empleados habilitados:', newOrder);
                }}
            />
        </Box>
    );
};

export default EmpleadosHabilitacionPage;